import React from 'react';
import {
  notEmptyString,
} from '@populateui/utils';
import clsx from 'clsx';
import {
  PCCDashboardProgramStatus,
} from 'dtos/pCCDashboardProgramStatus';
import {
  getPCCStatusPresentation,
} from 'pages/Dashboard/pages/Dashboard/PCCOverview/table/constants';

type Props = {
  status?: PCCDashboardProgramStatus;
  isOptedOut?: boolean;
};

export default function PCCProgramStatusPill({
  status,
  isOptedOut,
}: Props) {
  const statusPresentation = getPCCStatusPresentation(status, Boolean(isOptedOut));

  return notEmptyString(statusPresentation.label) ? (
    <span
      className={clsx(
        'inline-flex w-fit shrink-0 items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-semibold leading-4',
        statusPresentation.pillClassName,
      )}
    >
      <span
        className={clsx(
          'h-2 w-2 shrink-0 rounded-full',
          statusPresentation.dotClassName,
        )}
      />
      {statusPresentation.label}
    </span>
  ) : null;
}
